import { GetStartDataHandler } from './handlers/GetStartDataHandler';
import { PayHandler } from './handlers/PayHandler';
import { PaymentWindowIconClickHandler } from './handlers/paymentWindowIconClickHandler';
import { SetPreloaderHintHandler } from './handlers/setPreloaderHintHandler';
import { SetPreloaderProgressHandler } from './handlers/setPreloaderProgressHandler';
import { ShowClientHandler } from './handlers/ShowClientHandler';
import { WebCommands } from './webCommands';
import { SetClipboardContent } from './handlers/setClipboardContent';
import { EventServerLoginHandler } from './handlers/EventServerLoginHandler';
import { Event100ClicksHandler } from './handlers/Event100ClicksHandler';
import { EventFirstBuyHandler } from './handlers/EventFirstBuyHandler';
import { SetPayerInfoHandler } from './handlers/SetPayerInfoHandler';
import { SetRegistrationRefHandler } from './handlers/SetRegistrationRefHandler';
import { SendTutorCompletedHandler } from './handlers/SendTutorCompletedHandler';
import { FbTutorialCompleteHandler } from './handlers/FbTutorialCompleteHandler';
import { FbCapitolUpgradedHandler } from './handlers/FbCapitolUpgradedHandler';
import { CityLevelUpHandler } from './handlers/cityLevelUpHandler';
import { EventSuccessBuyHandler } from './handlers/EventSuccessBuyHandler';
import { EventRebillBuyHandler } from './handlers/EventRebillBuyHandler';
import { EventPaymentFinishedHandler } from './handlers/EventPaymentFinishedHandler';
import { SetTutorFinished } from './handlers/SetTutorFinishedHandler';
import { DontKillMePlsHandler } from './handlers/DontKillMePlsHandler';
import { HeroLevelUpHandler } from './handlers/heroLevelUpHandler';
import { Marches9Handler } from './handlers/Marches9Handler';
import { ValorMonster1000Handler } from './handlers/valorMonster1000Handler';
import { UnitsTrainSilver10000Handler } from './handlers/unitsTrainSilver10000Handler';
import { MonsterLvl5Handler } from './handlers/MonsterLvl5Handler';
import { ValorMonster1000PerMarchHandler } from './handlers/valorMonster1000PerMarchHandler';
import { GetMaintenanceDataHandler } from './handlers/GetMaintenanceDataHandler';
import { GetConsentStateHandler } from './handlers/GetConsentStateHandler';
import { GetFacebookAccessTokenHandler } from './handlers/GetFacebookAccessTokenHandler';
import { GetGoogleAccessTokenHandler } from './handlers/GetGoogleAccessTokenHandler';
import { SetConsentStateHandler } from './handlers/SetConsentStateHandler';
import { OpenPolicyWindowHandler } from './handlers/OpenPolicyWindowHandler';
import { PollingWindowHandler } from './handlers/PollingWindowHandler';
import { GetNotificationsStateHandler } from './handlers/GetNotificationsStateHandler';
import { SetNotificationsStateHandler } from './handlers/SetNotificationsStateHandler';
import { GetNotificationsBrowserStateHandler } from './handlers/GetNotificationBrowserStateHandler';
import { AnalyticsEventHandler } from './handlers/AnalyticsEventHandler';
import { SetPreloaderBackground } from './handlers/setPreloaderBackground';
import { EventStorageClosedHandler } from './handlers/EventStorageClosedHandler';
import { EventStorageOpenedHandler } from './handlers/EventStorageOpenedHandler';
import { EventBankOpenedHandler } from './handlers/EventBankOpenedHandler';
import { EventBankClosedHandler } from './handlers/EventBankClosedHandler';
import { SwitchCurrentCharacter } from './handlers/switchCurrentCharacter';
import { SetGameClientSize } from './handlers/SetGameClientSize';
import { StartAccountLinkingReward } from './handlers/StartAccountLinkingReward';
import { UpdateSimulatedPlayerStatus } from './handlers/updateSimulatedPlayerStatusHandler';
import { GetStartShortDataHandler } from './handlers/GetStartShortDataHandler';
import { OpenSupportWidgetHandler } from './handlers/OpenSupportWidgetHandler';

/* Тут мапим хэндлеры, которые дергает клиент игры */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const commandHandlerMap:any = {
    [WebCommands.ANALYTICS_EVENT]: AnalyticsEventHandler,
    [WebCommands.CITY_LEVEL_UP]: CityLevelUpHandler,
    [WebCommands.DONT_KILL_ME_PLS]: DontKillMePlsHandler,
    [WebCommands.EVENT_100_CLICKS]: Event100ClicksHandler,
    [WebCommands.EVENT_FIRST_BUY]: EventFirstBuyHandler,
    [WebCommands.EVENT_PAYMENT_FINISHED]: EventPaymentFinishedHandler,
    [WebCommands.EVENT_REBILL_BUY]: EventRebillBuyHandler,
    [WebCommands.EVENT_SERVER_LOGIN]: EventServerLoginHandler,
    [WebCommands.EVENT_SUCCESS_BUY]: EventSuccessBuyHandler,
    [WebCommands.FB_CAPITOL_UPGRADED]: FbCapitolUpgradedHandler,
    [WebCommands.FB_TUTORIAL_COMPLETE]: FbTutorialCompleteHandler,
    [WebCommands.GET_CONSENT_STATE]: GetConsentStateHandler,
    [WebCommands.GET_FACEBOOK_ACCESS_TOKEN]: GetFacebookAccessTokenHandler,
    [WebCommands.GET_GOOGLE_ACCESS_TOKEN]: GetGoogleAccessTokenHandler,
    [WebCommands.GET_MAINTENANCE_DATA]: GetMaintenanceDataHandler,
    [WebCommands.GET_START_DATA]: GetStartDataHandler,
    [WebCommands.GET_START_SHORT_DATA]: GetStartShortDataHandler,
    [WebCommands.HERO_LEVEL_UP]: HeroLevelUpHandler,
    [WebCommands.MARCHES_9]: Marches9Handler,
    [WebCommands.MONSTER_LVL_5]: MonsterLvl5Handler,
    [WebCommands.OPEN_POLICY_WINDOW]: OpenPolicyWindowHandler,
    [WebCommands.OPEN_SUPPORT_WIDGET]: OpenSupportWidgetHandler,
    [WebCommands.PAYMENT_WINDOW_ICON_CLICK]: PaymentWindowIconClickHandler,
    [WebCommands.PAY]: PayHandler,
    [WebCommands.SEND_TUTOR_COMPLETED]: SendTutorCompletedHandler,
    [WebCommands.SET_CLIPBOARD_CONTENT]: SetClipboardContent,
    [WebCommands.SET_CONSENT_STATE]: SetConsentStateHandler,
    [WebCommands.SET_PAYER_INFO]: SetPayerInfoHandler,
    [WebCommands.SET_PRELOADER_HINT]: SetPreloaderHintHandler,
    [WebCommands.SET_PRELOADER_PROGRESS]: SetPreloaderProgressHandler,
    [WebCommands.SET_REGISTRATION_REF]: SetRegistrationRefHandler,
    [WebCommands.SET_TUTOR_FINISHED]: SetTutorFinished,
    [WebCommands.SHOW_CLIENT]: ShowClientHandler,
    [WebCommands.UNITS_TRAIN_SILVER_10000]: UnitsTrainSilver10000Handler,
    [WebCommands.VALOR_MONSTER_1000]: ValorMonster1000Handler,
    [WebCommands.VALOR_MONSTER_1000_PER_MARCH]: ValorMonster1000PerMarchHandler,
    [WebCommands.OPEN_POLLING_WINDOW]: PollingWindowHandler,
    [WebCommands.GET_NOTIFICATIONS_STATE]: GetNotificationsStateHandler,
    [WebCommands.SET_NOTIFICATIONS_STATE]: SetNotificationsStateHandler,
    [WebCommands.GET_NOTIFICATIONS_BROWSER_STATE]: GetNotificationsBrowserStateHandler,
    [WebCommands.SET_PRELOADER_BACKGROUND]: SetPreloaderBackground,
    [WebCommands.EVENT_STORAGE_OPENED]: EventStorageOpenedHandler,
    [WebCommands.EVENT_STORAGE_CLOSED]: EventStorageClosedHandler,
    [WebCommands.EVENT_BANK_OPENED]: EventBankOpenedHandler,
    [WebCommands.EVENT_BANK_CLOSED]: EventBankClosedHandler,
    [WebCommands.SWITCH_CURRENT_CHARACTER]: SwitchCurrentCharacter,
    [WebCommands.SET_GAME_CLIENT_SIZE]: SetGameClientSize,
    [WebCommands.START_ACCOUNT_LINKING_REWARD]: StartAccountLinkingReward,
    [WebCommands.UPDATE_SIMULATED_PLAYER_STATUS]: UpdateSimulatedPlayerStatus
};

export function getCommandHandler(command: WebCommands) {
    const Handler = commandHandlerMap[command];

    if (!Handler) {
        throw new Error(`No handler found for web command ${command}`);
    }

    return new Handler();
}
